export default __webpack_public_path__ + "static/Request of Fees Refund Form-08751a4e44988b251bbdf68264883806.pdf";